// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Toast from 'vue-easy-toast'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
require('vue-easy-toast/dist/vue-easy-toast.css') // optional
Vue.use(Toast)
Vue.use(VueAxios,axios)
import ElementUi from 'element-ui'
//import './element-variables.scss'
//import 'element-ui/lib/theme-chalk/index.css';
import '../static/style/theme/index.css'
Vue.use(ElementUi, { zIndex: 100000 })
import VConsole from 'vconsole';
if(location.href.indexOf('--DEBUG--')>-1){
  const vConsole = new VConsole();
}
if(!Vue.hasToast){
  Vue.hasToast=true
  let VueToast=Vue.toast
  Vue.toastSuccess=function(msg){
    return VueToast(msg,{
      horizontalPosition:'center',
      verticalPosition:'top',
      duration:3000,
      className:'toast-center toast-success'
    })
  }
  Vue.toast=function(msg){
    return VueToast(msg,{
      horizontalPosition:'center',
      verticalPosition:'top',
      duration:3000,
      className:'toast-center'
    })
  }
  Vue.getOpenid=function(act=''){
    /*
    let openid=this.$cookies.get('openid')
    if(!openid){
      if(location.href.indexOf('http://localhost:8080')>-1){
        return 'oTJd-v3xnlHsiY7zeKHGL0p6Sc30';
      }
      return location.replace('http://nc.colorcun.com/index.php?service=App.Auth.GetBaseInfo&act='+encodeURI(act))
    }
    return openid
    */
  }
}

Vue.config.productionTip = false
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title||'Fotoo'
  next()
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js